import { graphql, useStaticQuery } from "gatsby";

export const navigationLinks = () => {
  const data = useStaticQuery(graphql`
    query {
      cirugias: allContentfulCirugias {
        nodes {
          title
          slug
          categorias
        }
      }
      tratamientos: allContentfulTratamientos {
        nodes {
          title
          slug
          categorias
        }
      }
      cosmiatria: allContentfulCosmiatriaYAparatologia {
        nodes {
          title
          slug
          categorias
        }
      }
      profesionales: allContentfulProfesionales {
      nodes {
        profesional
        slug
      }
    }
    }
  `);

  const getUniqueCategories = (nodes) => {
    const categories = nodes
      .flatMap((node) => node.categorias) 
      .filter((category, index, self) => self.indexOf(category) === index); 
    return categories;
  };

  return [
    { 
      name: "cirugías", 
      categories: getUniqueCategories(data.cirugias.nodes),
      posts: data.cirugias.nodes, 
      url: "/cirugias/" 
    },
    { 
      name: "cosmiatría & aparatología", 
      categories: getUniqueCategories(data.cosmiatria.nodes),
      posts: data.cosmiatria.nodes, 
      url: "/cosmiatria-y-aparatologia/" 
    },
    { 
      name: "tratamientos", 
      categories: getUniqueCategories(data.tratamientos.nodes),
      posts: data.tratamientos.nodes, 
      url: "/tratamientos/" 
    },
    { name: "Productos", url: "/productos" },
    { name: "Nosotros",
      submenu: [
        {
          name: "Profesionales",
          sublinks: data.profesionales.nodes.map(prof => ({
            name: prof.profesional,
            url: `/profesionales/${prof.slug}`
          }))
        },
        { name: "Nuestra Clínica", url: "/clinica-milito" }, 
      ]
    },
    { name: "Blog", url: "/blog" },
    { name: "Contacto", url: "/contacto" },
  ];
};



import React from "react";
import WhatsApp from "../../assets/icons/icon-whatsapp-menu.inline.svg";
import Instagram from "../../assets/icons/icon-instagram-menu.inline.svg";

export const useSocialLinks = () => {
  return [
    {
      href: "https://api.whatsapp.com/send/?phone=5491148700517&text&type=phone_number&app_absent=0",
      icon: <WhatsApp />,
      name: "WhatsApp"
    },
    {
      href: "https://www.instagram.com/clinicamilito/?hl=es",
      icon: <Instagram />,
      name: "Instagram"
    }
  ];
};
